import { IPolicyType } from "../../../services/api/insurance/coverage/types";
import { IPlanType } from "../../../services/api/planEnrollment/types";
import { getOAIBenefitListItem } from "../../Benefits/components/customBenefits/OAI/getOAIBenefitListItem";

export const selectorPolicyNameByPolicyType = (
  policyType: IPolicyType,
  planType: IPlanType
): string => {
  const names: Partial<Record<IPolicyType, string>> = {
    OccupationalAccident: getOAIBenefitListItem().name,
    GeneralLiability:
      "Wingspan Professional & General Liability Insurance (GL)",
    ProfessionalLiability:
      "Wingspan Professional & General Liability Insurance (PL)"
  };

  return names[policyType] || "Insurance coverage";
};
